import { ExpressionType } from '../ExpressionType';
import createBinaryExpression from './createBinaryExpression';
export default function createNotEqual(left, right) {
    return createBinaryExpression(ExpressionType.NotEqual, left, right);
}
